import { render, staticRenderFns } from "./LeftTextBorder.vue?vue&type=template&id=1681b366&scoped=true"
import script from "./LeftTextBorder.vue?vue&type=script&lang=js"
export * from "./LeftTextBorder.vue?vue&type=script&lang=js"
import style0 from "./LeftTextBorder.vue?vue&type=style&index=0&id=1681b366&prod&lang=scss&scoped=true"
import style1 from "./LeftTextBorder.vue?vue&type=style&index=1&id=1681b366&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1681b366",
  null
  
)

export default component.exports